import { render, staticRenderFns } from "./DialogUpdateNote.vue?vue&type=template&id=f0adc31a&"
import script from "./DialogUpdateNote.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateNote.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdateNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0adc31a')) {
      api.createRecord('f0adc31a', component.options)
    } else {
      api.reload('f0adc31a', component.options)
    }
    module.hot.accept("./DialogUpdateNote.vue?vue&type=template&id=f0adc31a&", function () {
      api.rerender('f0adc31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogUpdateNote.vue"
export default component.exports